(() => {
  const getWrappers = () => Array.from(document.querySelectorAll('[data-icon-status]'));

  const closeAllIconStatusModals = () => {
    getWrappers().forEach((wrapper) => {
      const trigger = wrapper.querySelector('[data-icon-status-trigger]');
      const modal = wrapper.querySelector('[data-icon-status-modal]');
      if (!(trigger instanceof HTMLButtonElement) || !(modal instanceof HTMLElement)) return;
      trigger.setAttribute('aria-expanded', 'false');
      modal.hidden = true;
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-icon-status-trigger]');
    if (trigger) {
      const wrapper = trigger.closest('[data-icon-status]');
      if (!wrapper) return;
      const modal = wrapper.querySelector('[data-icon-status-modal]');
      if (!(modal instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopPropagation();

      const isOpen = modal.hidden === false;
      closeAllIconStatusModals();
      modal.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    if (!target.closest('[data-icon-status]')) {
      closeAllIconStatusModals();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllIconStatusModals();
    }
  });
})();

